// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PieChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import cfgFactories from 'share/factories/Izenda.ReportPartStyleConfigurationFactories';
import localizer from 'share/localization/Izenda.Localizer';
import PieChartOptionsBuilder from './Izenda.PieChartOptionsBuilder';

import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import {
  XAXIS_LABEL_KEY,
  YAXIS_VALUE_KEY,
  createXAxisCustomNameSchema,
  createYAxisCustomNameSchema,
  createSeparatorSchema
} from '../FieldContainers/Izenda.FieldContainerSchemaFunctions';
import { CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';
import VISUAL_TYPE from 'share/components/charting/highcharts/Izenda.VisualTypeMapping';

cfgFactories.extendConfiguration(REPORT_PART_TYPE.Chart, CHART_TYPE.Pie, null, {
  visualType: VISUAL_TYPE.Pie,

  get visualLabel() {
    return localizer.getText('REPORT_CHART_TYPE_PIE');
  },

  visualPreviewCSS: 'chart-pie',

  optionsBuilder: PieChartOptionsBuilder,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [
    createXAxisCustomNameSchema(undefined, XAXIS_LABEL_KEY, true),
    createYAxisCustomNameSchema(undefined, YAXIS_VALUE_KEY, true),
    createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izUseSeparator: { defaultValue: true },
      izBottomXpercent: { propKey: 'izendaOptions.bottomXpercent', defaultValue: 0 },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: true },
      izLabelOrientation: { defaultValue: undefined },

      izShowPercentage: { propKey: 'izendaOptions.showPercentage', defaultValue: undefined },
      izSliceLabel: { propKey: 'izendaOptions.showSliceLabel', defaultValue: undefined },
      izValueLabel: { propKey: 'izendaOptions.showValueLabel', defaultValue: undefined },
      izShowValueFieldName: { propKey: 'izendaOptions.showValueFieldName', defaultValue: undefined },

      izPieChartStyle: { propKey: 'izendaOptions.pieChartStyle', defaultValue: 'basic' },
      legendSettings: { defaultValue: true },

      izUsePagination: { defaultValue: true },
      izItemPerRow: { defaultValue: 2 }
    }
  }
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.PieChartConfiguration.js